import { ColorManager } from 'vet-bones/utils';

import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectModel, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to add `colorIdsByIri` to each project model and the diagram model modelData
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v24 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v24Projects(prevState.projects);
  }

  return nextState;
};

const v24Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const updatedModelsById = Object.values(project.modelsById).reduce<
      Record<string, ProjectModel>
    >((acc, model) => {
      const updatedModel: ProjectModel = { ...model, colorIdsByIri: {} };
      acc[updatedModel.id] = updatedModel;
      return acc;
    }, {});

    const colorIdsByIri: Record<string, string> = {};
    const colorManager = new ColorManager();
    project.diagram.model.nodeDataArray.forEach((nodeData) => {
      if (isModelConceptClass(nodeData)) {
        const newColor = colorManager.getColorForIri(nodeData.value);
        colorIdsByIri[nodeData.value] = newColor.id;
      }
    });

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            colorIdsByIri,
          },
        },
      },
      modelsById: updatedModelsById,
    };
  });

  return { ...prevProjectsState, projectsById };
};
